import ReactSelect from 'react-select';
import { useSelector } from 'react-redux';
import { forwardRef } from 'react';

const sortArray = (array, sortBy,  sortingOrder = "ascending") => {
  if(!array) return []; // handle if null value is passed
  if(array.length < 1) return array;
  if(typeof array[0][sortBy] === 'string' && sortingOrder === "ascending") {
    return [...array]?.sort((a, b) => a[sortBy]?.localeCompare(b[sortBy]))
  }

  if(typeof array[0][sortBy] === 'number' && sortingOrder === "ascending") {
    return [...array].sort((a, b) => a[sortBy] > b[sortBy] ? 1: -1)
  }

  if(typeof array[0][sortBy] === 'string' && sortingOrder === "descending") {
    return [...array].sort((a, b) => a[sortBy].localeCompare(b[sortBy]))
  }

  if(typeof array[0][sortBy] === 'number' && sortingOrder === "descending") {
    return [...array].sort((a, b) => a[sortBy] < b[sortBy] ? 1: -1)
  } 

  return array
}

  export const customStyles = (skillsNotMatch) => ({
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '1px solid #87E64B' : themeMode === 'light' ? '1px solid  #98A0AE' : '1px solid #FFFFFF',
      border: state.isDisabled ? '1px solid #999' : themeMode === 'light' ? '1px solid  #98a0ae' : '1px solid #e6e6e6',
      boxShadow: state.isFocused ? '0px 0px 1px #87E64B' : 'none',
      background: themeMode === 'light' ? '' : '#051A38',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: themeMode === 'light' ? 'black' : 'white',
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      background: themeMode === 'light' ? 'dark' : '#051A38',
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isFocused ? (themeMode === 'dark' ? 'rgba(135, 230, 75, 0.35)' : 'rgba(135, 230, 75, 0.2)') : undefined,
      color: state.isFocused || state.isSelected ? '#000' : (themeMode === 'light' ? '#666c75' : 'white'),
      borderLeft: themeMode === 'dark' ? '2px solid #051A38' : 'none',
      borderRight: themeMode === 'dark' ? '2px solid #051A38' : 'none',
      '&:hover': {
        ...styles,
        backgroundColor: state.isDisabled ? undefined : state.isFocused ? (themeMode === 'dark' ? 'rgba(135, 230, 75, 0.35)' : 'rgba(135, 230, 75, 0.2)') : undefined,
        color: state.isFocused ? '#000' : undefined,
      },
    }),
    input: (provided) => ({
      ...provided,
      color: themeMode === 'light' ? 'black' : 'white',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#6e6b7b',
        fontSize: '11px',
        fontWeight: '500',
      };
    },
    valueContainer: (base) => ({
      ...base,
      height: 38,
      overflow:'auto',
      "::-webkit-scrollbar": {
        width: "1px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1"
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888"
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555"
      }
    }), 
    multiValue: (provided, state) => {
      let background = '#87E64B';
      if (skillsNotMatch?.some((el) => el === state.data.value)) {
        background = '#ff9999'; // red for 'non match'
      }
      return {
        ...provided,
        backgroundColor: background,
      };
    },
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#000',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#000',
      ':hover': {
        backgroundColor: 'rgba(135, 230, 75, 0.6)',
        color: '#000',
      },
    }),
  });

const Select = forwardRef((props, ref) => {
  const { styles, className, skillsNotMatch } = props;
  const themeMode = useSelector((state) => state.layout.themeMode);

  let { options, sortBy, sortingOrder, trailingOptions, ...restProps } = props
  if(!!sortBy) {
    options = sortArray(options, sortBy, sortingOrder)
  }

  if(trailingOptions) {
    if(Array.isArray(trailingOptions)) {
      options = options.concat(trailingOptions);
    } else {
      console.error("Select component expects and array");
    }
  }

  return (
    <ReactSelect
      ref={ref}
      {...restProps}
      options={options}
      styles={styles ? styles : customStyles(skillsNotMatch)}
      className={className ? className : themeMode === 'dark' ? 'basic-select-dark' : ''}
    />
  );
});

export default Select;
